<template>
  <!-- The Gain Livinar -->
    <div id="tgl">
        <div class="pt-5 pb-3" id="livinar">
            <b-container fluid class="bv-example-row">
                <b-row>
                    <b-col sm="12" lg="6" class="livinar1"> 
                        <h4> Just change your habits with Time,<br> Focus, Clarity &amp; Reality and you can:</h4>
                        <div class="checklists"> 
                            <h4>
                                <table>
                                    <tbody>
                                    <tr> 
                                        <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img></td>
                                        <td class="check-para"> Double Your Business </td>
                                    </tr>
                                    <tr> 
                                        <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                                        <td class="check-para"> Deepen Your Family Bond </td>
                                    </tr>
                                    <tr> 
                                        <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                                        <td class="check-para"> Do Something you always Dream of </td>
                                    </tr>
                                    <tr> 
                                        <td><b-img :src="images.check" class="check" fluid alt="check image"></b-img> </td>
                                        <td class="check-para"> Achieve any Goal that you set </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </h4>
                        </div>
                        <h4 class="pt-5 pb-5 pl-2"><b>Not Just Once, but Week after Week.</b></h4>
                    </b-col>
                    <b-col sm="12" lg="6" id="tgl-2" class="text-center">
                        <div class="top-left-borders">
                        </div>
                        <h4 class="text-center pt-5"> 'Make It Happen' <br> in just 90 days at Colloquium</h4>
                        <div class="gradient">
                            <b-img :src="images.tgltext" id="tgl-img" fluid alt="TGL Text image"></b-img>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

        </div>
        <div class="text-center pt-5 pb-3">
            <h5>But first experience it at our Free Million Dollar Habits Demo</h5>
            <div id="register_no">
                <cq-btn>REGISTER NOW</cq-btn>
            </div>
        </div>
    </div>
    <!-- End The Gain Livinar -->
</template>

<script>
import CQButton from '../../components/ui/CQButton.vue'

// Import Images
import tgltext from '../../assets/image/home/tgltext.png'
import check from  '../../assets/image/common/check.png'

export default {
    components: {
        'cq-btn' : CQButton
    },
    data() {
        return {
            images: { 
                tgltext,
                check
            }
        }
    }
}
</script>

<style scoped>
#tgl >>> #livinar{
  background-image: url(../../assets/image/home/tgl.png);
  background-repeat: no-repeat;
  background-size: cover;
}

#tgl >>> .check{
  min-height: 25px;
  /* font-size: 50px; */
}

#tgl >>> .check-para{
  padding-left: 10px;
  padding-top: 1%;
  font-size: 1.7rem;
}

#tgl >>> h4 {
  padding-right: 10px;
  padding-top: 1%;
  font-size: 1.7rem;
}

#tgl >>> h5{
    font-size: 1.6rem;
}

#tgl >>> .top-left-borders{
  border-left: 4px solid var(--primary-color);
  border-top: 4px solid var(--primary-color);
  width: 150px;
  height: 150px;
  position: absolute;
}

#tgl >>> .gradient{
  padding: 7% 0%;
}

#tgl >>> #register_no .cq-btn{
    padding: 20px 0 !important;
}

#tgl >>> .fa{
    color: #fff;
}

/* Mobile View */
@media only screen and (max-width: 992px){
    #tgl >>> #tgl-2{
        padding-top: 30px !important;
    }

    #tgl >>> .gradient{
        padding: 12% 0%;
    }

    /* #tgl >>> .livinar1{
        padding-left: 50px !important; 
    } */

    #tgl >>> #tgl-img{
        max-width: 80%;
    }

    #tgl >>> tr{
        vertical-align: top;
    }

}

/* Desktop View */
@media only screen and (min-width: 992px){
    #tgl >>> .gradient img{
        max-width: 60% !important;
    }

    #tgl >>> .check{
        min-height: 75px;
    }

    #tgl >>> .livinar1{
    padding-left: 100px !important; 
  }
}
</style>